import React from 'react';
import styled from 'styled-components';
import { FONTS, COLORS, BREAKPOINTS } from '../utils/styleConstants';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    padding: 1.5rem;
    width: 95%;
  }
`;

const ModalTitle = styled.h3`
  color: ${COLORS.PRIMARY};
  font-size: 1.5rem;
  font-weight: 600;
  font-family: ${FONTS.PRIMARY};
  margin-bottom: 1rem;
`;

const ModalMessage = styled.p`
  color: ${COLORS.SECONDARY};
  font-size: 1rem;
  font-family: ${FONTS.SECONDARY};
  line-height: 1.5;
  margin-bottom: 2rem;
`;

const ModalButton = styled.button`
  background-color: ${COLORS.PRIMARY};
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  font-family: ${FONTS.PRIMARY};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1a2d5a;
  }

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
  }
`;

const NetworkStatusModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalTitle>Sin conexión a internet</ModalTitle>
        <ModalMessage>
          No se puede guardar el borrador ni continuar al siguiente paso sin conexión a internet. 
          Por favor, verifica tu conexión e inténtalo de nuevo.
        </ModalMessage>
        <ModalButton onClick={onClose}>
          Entendido
        </ModalButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default NetworkStatusModal; 